import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { iconPaths } from '../../../../react/constants/icons';

const ArrowDown = (props: SvgIconProps): JSX.Element => (
	<SvgIcon style={{ width: 14, height: 14, top: 16, right: 16 }} {...props}>
		<path d={iconPaths.arrowDown} />
	</SvgIcon>
);

export default ArrowDown;
